import React from "react";
import { Container, Row, Col } from "shards-react";

import VerifiedStudents from "./Verified";
import NonVerifiedStudents from "./NonVerified";
import MainNavbar from "../../components/layout/MainNavBar/MainNavBar";
import MainSidebar from "../../components/layout/MainSideBar/MainSideBar";
import MainFooter from "../../components/layout/MainFooter/MainFooter";
const Dashboard = ({ noNavbar, noFooter, verified, ...props }) => (
  <Container fluid>
    <Row>
      <MainSidebar />
      <Col
        className="main-content p-0"
        lg={{ size: 10, offset: 2 }}
        md={{ size: 9, offset: 3 }}
        sm="12"
        tag="main"
      >
        {!noNavbar && <MainNavbar {...props} />}
        {!verified ? <NonVerifiedStudents /> : <VerifiedStudents />}
        {!noFooter && <MainFooter />}
      </Col>
    </Row>
  </Container>
);
export default Dashboard;
